const HamburgerIcon = ({ className = "w-8 h-8", fill = "currentColor" }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <line
        x1="5.5"
        y1="7.75"
        x2="19.5"
        y2="7.75"
        stroke={fill}
        stroke-width="2"
        stroke-linecap="round"
      />
      <line
        x1="5.5"
        y1="14.25"
        x2="19.5"
        y2="14.25"
        stroke={fill}   
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export default HamburgerIcon;
